import React from 'react'
import MyTable from '../../UI/table/MyTable'
import { TableCell } from '@mui/material'
import MyTableNotFound from '../../UI/table/MyTableNotFound'
import WriteOffActItem from './WriteOffActItem'

const WriteOffActTable = ({ writeOffActs, count, offset, setOffset, limit, setLimit, loading }) => {
  return (
    <MyTable
        head={
            <>
                <TableCell align="center">ID</TableCell>
                <TableCell align="center">Статус</TableCell>
                {/* <TableCell align="center">Заявник</TableCell> */}
                <TableCell align="center">Відповідальний</TableCell>
                <TableCell align="center">Підрозділ</TableCell>
                <TableCell align="center">Погодження</TableCell>
                {/* <TableCell align="center">Доставлено</TableCell> */}
                <TableCell align="center">Дата створення</TableCell>
                {/* <TableCell align="center">Дії</TableCell> */}
            </>
        }
        body={
            writeOffActs && writeOffActs.length > 0 ?
                writeOffActs.map(writeOffAct => 
                    <WriteOffActItem
                        key={writeOffAct.id}
                        writeOffAct={writeOffAct} 
                    />
                )
            : 
                <MyTableNotFound
                    text='Заявок не знайдено' 
                    // columns={6}
                />
        }
        name='заявок'
        count={count}
        limit={limit}
        setLimit={setLimit}
        offset={offset}
        setOffset={setOffset}
        loading={loading}
        isIconMore={true}
    />
  )
}

export default WriteOffActTable